import React, { Fragment } from "react";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import BlogSingle from "../../components/BlogDetails/BlogSingle.js";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer.js";

const BlogDetailsFull = () => {
  return (
    <Fragment>
      <Navbar hclass={"wpo-header-style-3"} />
      <PageTitle pageTitle={"Latest News"} pagesub={"Blog"} />
      <BlogSingle blLeft={"d-none"} blRight={"col-lg-10 offset-lg-1"} />
      <Footer footerClass={"wpo-site-footer-s2"} />
      <Scrollbar />
    </Fragment>
  );
};
export default BlogDetailsFull;
